import { FunctionsHttpError, FunctionsRelayError, FunctionsFetchError } from '@supabase/supabase-js';

/** Extrai mensagem legível de erros de supabase.functions.invoke().
 *  Em non-2xx o corpo JSON da Edge vive em error.context (Response). */
export async function readEdgeFunctionError(error: unknown): Promise<string> {
  if (error instanceof FunctionsHttpError) {
    try {
      const body = await error.context.json();
      return body?.message || body?.error || error.message;
    } catch {
      return error.message; // corpo não-JSON, vazio ou já consumido
    }
  }
  if (error instanceof FunctionsRelayError) return 'Falha de comunicação com o servidor. Tente novamente.';
  if (error instanceof FunctionsFetchError) return 'Sem conexão com o servidor. Verifique sua internet.';
  return error instanceof Error ? error.message : 'Erro inesperado';
}
